/*
 * Copyright (c) 2005, The haXe Project Contributors
 * All rights reserved.
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 *   - Redistributions of source code must retain the above copyright
 *     notice, this list of conditions and the following disclaimer.
 *   - Redistributions in binary form must reproduce the above copyright
 *     notice, this list of conditions and the following disclaimer in the
 *     documentation and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE HAXE PROJECT CONTRIBUTORS "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE HAXE PROJECT CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
 * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH
 * DAMAGE.
 */
/**
 * package: haxe
 * class: Stack
 * root Object
 * @constructor
 */
haxe.Stack = function() {};
$hxClasses['haxe.Stack'] = haxe.Stack;
/** @private @type {Array} */
haxe.Stack.__name__ = ["haxe","Stack"];

/**
 * callStack
 * Return the call stack elements, or an empty array if not available.
 * *
 * --------------------- *
 *
 * $type TFun([],TInst(Array,[TEnum(haxe.StackItem,[])]))
 * @public
 * @static
 * @return {Array}
 */
haxe.Stack.callStack = function() {
	/** @type {Function} */
	var oldValue = Error.prepareStackTrace;
	Error.prepareStackTrace = function(error,callsites) {
		/** @type {Array} */ 
		var stack = [];
		/** @type {number} */ 
		var _g = 0;
		while(_g < callsites.length) {
			/** @type {Object} */
			var site = callsites[_g];
			++_g;
			/** @type {haxe.StackItem} */ 
			var method = null;
			/** @type {string} */ 
			var fullName = site.getFunctionName();
			if(fullName != null) {
				/** @type {number} */ 
				var idx = fullName.lastIndexOf(".");
				if(idx >= 0) {
					/** @type {string} */ 
					var className = HxOverrides.substr(fullName,0,idx);
					/** @type {string} */ 
					var methodName = HxOverrides.substr(fullName,idx + 1,null);
					method = haxe.StackItem.Method(className,methodName);
				}
			}
			stack.push(haxe.StackItem.FilePos(method,site.getFileName(),site.getLineNumber()));
		}
		return stack;
	};
	/** @type {Array} */ 
	var a = haxe.Stack.makeStack(new Error().stack);
	a.shift();/*  remove Stack.callStack()*/
	Error.prepareStackTrace = oldValue;
	return a;
};


/**
 * exceptionStack
 * Return the exception stack : this is the stack elements between
 * the place the last exception was thrown and the place it was
 * caught, or an empty array if not available.
 * *
 * --------------------- *
 *
 * $type TFun([],TInst(Array,[TEnum(haxe.StackItem,[])]))
 * @public
 * @static
 * @return {Array}
 */
haxe.Stack.exceptionStack = function() {
	return [];
};


/**
 * toString
 * Returns a representation of the stack as a printable string.
 * *
 * --------------------- *
 *
 * $type TFun([{ name => stack, t => TInst(Array,[TEnum(haxe.StackItem,[])]), opt => false }],TInst(String,[]))
 * public static function toString( stack : Array<StackItem> )
 * @public
 * @static
 * @param {Array}  stack 
 * @return {string}
 */
haxe.Stack.toString = function(stack) {
	/** @type {StringBuf} */ 
	var b = new StringBuf();
	/** @type {number} */ 
	var _g = 0;
	while(_g < stack.length) {
		/** @type {haxe.StackItem} */ 
		var s = stack[_g];
		++_g;
		b.b += Std.string("\nCalled from ");
		haxe.Stack.itemToString(b,s);
	}
	return b.b;
};


/**
 * itemToString
 *
 * $type TFun([{ name => b, t => TInst(StringBuf,[]), opt => false },{ name => s, t => TEnum(haxe.StackItem,[]), opt => false }],TEnum(Void,[]))
 * private static function itemToString( b : StringBuf, s )
 * @private
 * @static
 * @param {StringBuf}  b 
 * @param {haxe.StackItem}  s 
 * @return {void}
 */
haxe.Stack.itemToString = function(b,s) {
	switch(s) {
		case CFunction:
			b.b += Std.string("a C function");
			break;
		case Module(m):
			b.b += Std.string("module ");
			b.b += Std.string(m);
			break;
		case FilePos(s1,file,line):
			if(s1 != null) {
				haxe.Stack.itemToString(b,s1);
				b.b += Std.string(" (");
			}
			b.b += Std.string(file);
			b.b += Std.string(" line ");
			b.b += Std.string(line);
			if(s1 != null) b.b += Std.string(")");
			break;
		case Method(cname,meth):
			b.b += Std.string(cname);
			b.b += Std.string(".");
			b.b += Std.string(meth);
			break;
		case Lambda(n):
			b.b += Std.string("local function #");
			b.b += Std.string(n);
			break;
	}
};


/**
 * makeStack
 *
 * $type TFun([{ name => s, t => TAnonymous(<anonymous>), opt => false }],TInst(Array,[TEnum(haxe.StackItem,[])]))
 * private static function makeStack(s)
 * @private
 * @static
 * @param {TAnonymous(<anonymous>)}  s 
 * @return {Array}
 */
haxe.Stack.makeStack = function(s) {
	if(typeof(s) == "string") {
		/*  Return the raw lines in browsers that don't support prepareStackTrace */
		/** @type {Array} */ 
		var stack = s.split("\n");
		/** @type {Array} */ 
		var m = [];
		/** @type {number} */ 
		var _g = 0;
		while(_g < stack.length) {
			/** @type {string} */ 
			var line = stack[_g];
			++_g;
			m.push(haxe.StackItem.Module(line));/*  A little weird, but better than nothing*/
		}
		return m;
	} else return s;
};

/** @type {haxe.Stack} */
haxe.Stack.prototype.__class__ = haxe.Stack;
